export default {"src":"/_next/static/media/consult.85c90c5c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};